// enroll.js
import { select } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import { budgetApi } from './api';

// main mixin
import bankAccountMixin from '../shared/vue/mixins/bankAccount';
import loadingMixin from '../shared/vue/mixins/loading';
import multistepMixin from '../shared/vue/mixins/multistep';
import formMixin from '../shared/vue/mixins/form';
import dataLayerPush from '../shared/utils/analytics';

/**
 * Enrolling in auto pay
 */
const el = select('[data-vue-app="budget-payment"]');
if (el) {
  const app = new Vue({ // eslint-disable-line no-unused-vars
    el,
    delimiters,
    mixins: [loadingMixin, formMixin, multistepMixin, bankAccountMixin],
    data: {
      account: '',
      accountNumber: '',
      agree: false,
      date: '',
      // for accessibility in live regions
      liveText: '',
      loading: false,
      planId: null,
      payFromText: '',
      paymentDay: '',
      paymentDate: '',
      paymentType: '',
      paymentAmount: '',
      paymentMethod: '',
      receiptNumber: '',
      routingNumber: '',
      enrollSuccess: false,
      cancelSuccess: false,
      step: 1,
      hasMounted: false,
      errorMessage: null,
      budgetPlanOptions: [],
      enrolled: false,
      planAmount: 0,
      planDescription: null,
      loadPlanError: false,
      budgetEnrollment: null,
    },
    mounted() {
      this.budgetEnrollment = (this.$el.dataset && this.$el.dataset.serializedBudgetEnrollment) ? JSON.parse(this.$el.dataset.serializedBudgetEnrollment) : null;
      if (this.$el.dataset.enrollSuccess) {
        this.enrollSuccess = JSON.parse(this.$el.dataset.enrollSuccess);
        if (this.enrollSuccess) {
          this.setStep(4);
        }
      }

      Vue.nextTick(() => {
        this.loading = true;
        this.enrolled = this.budgetEnrollment !== null;
        if (!this.enrolled) {
          this.loadPlanOptions();
        } else {
          this.loading = false;
          this.setEnrolledPlanInfo(this.budgetEnrollment.paymentPlanAmount, this.budgetEnrollment.description);
          this.setStep(4);
        }
      });
    },
    created() {
      Event.$on('A11yDialogConfirm:confirm-budget-cancel', () => {
        this.cancelEnrollment();
      });
    },
    computed: {
      fullDescription() {
        if (this.enrolled) {
          return `$${this.planAmount} ${this.planDescription}`
        }

        const selectedPlan = this.findSelectedBudgetPlan();
        return selectedPlan ? `$${selectedPlan.planAmount} ${selectedPlan.description}` : "";
      },
      canEnroll() {
        return !this.loadPlanError;
      },
    },
    watch: {
      step(newVal, oldVal) { // eslint-disable-line no-unused-vars
        /**
         * Changes live text depending on the form step
         */
        if (this.step === 2) {
          this.liveText = 'Moving to Step 2 to confirm your details';
        } else if (this.step === 1) {
          this.liveText = 'You are now back on Step 1 to set up your budget plan information';
        } else if (this.step === 3) {
          this.liveText = 'Moving to Step 3 to complete budget plan enrollment';
        }
      },
    },
    methods: {
      postFormContents() {
        const budgetPlan = this.findSelectedBudgetPlan();
        budgetApi.enrollInBudget(budgetPlan)
          .then(() => {
            this.loading = false;
            this.enrollSuccess = true;
            dataLayerPush('BudgetPPEnroll');
            if (!window.fabricator) {
              window.location.href = "/budget/enroll/success";
            }
          });
      },

      setEnrolledPlanInfo(paymentPlanAmount, description) {
        this.planAmount = paymentPlanAmount;
        this.planDescription = description;
      },

      loadPlanOptions() {
        this.loading = true;
        return budgetApi.getBudgetPlanOptions()
          .then((response) => {
            this.budgetPlanOptions = response.data.plans;
            if (this.budgetPlanOptions.length === 1) {
              this.planId = this.budgetPlanOptions[0].planId;
            }
            this.loading = false;
            this.loadPlanError = false;
          })
          .catch(() => {
            this.loading = false;
            this.loadPlanError = true;
          });
      },

      cancelEnrollment() {
        this.loading = true;
        budgetApi.cancelBudgetEnrollment()
          .then(() => {
            this.cancelSuccess = true;
            dataLayerPush('BudgetPPUnenroll');
            if (!window.fabricator) {
              window.location.href = "/budget/cancel/success";
            }
          });
      },

      findSelectedBudgetPlan() {
        const results = this.budgetPlanOptions.filter(p => p.planId === this.planId);
        if (results.length === 0) {
          return null;
        }
        return results[0];
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/budget-payment.js